export default {"src":"/_next/static/image/public/images/ic_calendar.1e7f6a95f5693829b39828933854806e.svg","height":15,"width":14};